import { combineReducers, configureStore } from '@reduxjs/toolkit'
import mainReducer from './reducers/mainSlice.js'
import userReducer from './reducers/userSlice.js'
import persistReducer from 'redux-persist/es/persistReducer'
import persistStore from 'redux-persist/es/persistStore'
import storage from 'redux-persist/lib/storage'
import superAdminReducer from './reducers/superAdminSlice.js'
import alertReducer from './reducers/alertSlice.js'
import subscriptionReducer from './reducers/subscriptionSlice.js'
import LanguageReducer from './reducers/languageSlice.js'
import CohortReducer from './reducers/cohortSlice.js'
import unitReducer from './reducers/unitSlice.js'
import seasonReducer from './reducers/seasonSlice.js'
import moduleReducer from './reducers/moduleSlice.js'
import categoryReducer from './reducers/categorySlice.js'
import courseReducer from './reducers/CourseSlice.js'
import programReducer from './reducers/programSlice.js'
import videoReducer from './reducers/videoSlice.js'

const superAdminPersistConfig = {
    key: 'superAdmin',
    storage,
}
const persistedSuperAdminReducer = persistReducer(superAdminPersistConfig , superAdminReducer);

const rootReducer = combineReducers({
    main: mainReducer,
    language: LanguageReducer,
    user: userReducer,
    alert:alertReducer,
    unit:unitReducer,
    module:moduleReducer,
    cohort:CohortReducer,
    superAdmin:persistedSuperAdminReducer,
    subscription:subscriptionReducer,
    category:categoryReducer,
    course:courseReducer,
    program:programReducer,
    video: videoReducer,
    season:seasonReducer
})

export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
            }
        }),
})

export const persistor = persistStore(store)